/*
*****************************************************************************
*File :router.js
*Module : Dashboard Frontend
*Purpose :Defining the routers for the cyberS Application
*Author : UI Team
*Copyright : Copyright 2021, Lab to Market Innovations Private Limited
*****************************************************************************
*/

import Vue from 'vue'
import Router from 'vue-router'
import DatetimePicker from 'vuetify-datetime-picker'
import VuetifyDaterangePicker from 'vuetify-daterange-picker'
import { Role } from '@/role'
import store from './store'
import VueRouter from 'vue-router'
Vue.use(VueRouter)

Vue.use(Router)
Vue.use(DatetimePicker)
Vue.use(VuetifyDaterangePicker)

// export default new Router({
export const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      component: () => import('@/views/login/Index'),
      children: [
        {
          name: 'Login',
          path: '',
          component: () => import('@/views/login/Login'),
        },
      ],
    },
    {
      path: '/',
      name: 'MVIS',
      component: () => import('@/views/dashboard/Index'),
      children: [
        /*{
          name: 'Train Consolidated Report',
          path: 'report/train-information',
          component: TrainInformation,
          meta: { authorize: [] },
        },*/
        {
          name: 'Performance',
          path: 'yard',
          component: () => import('@/views/dashboard/yard'),
          meta: { authorize: [] }
        },
        {
          name: 'Day View',
          path: 'yard/day-view',
          component: () => import('@/views/yard/day-view'),
          meta: { authorize: [] }
        },
        {
          name: 'Report',
          path: 'report',
          meta: { authorize: [] }
        },
        {
          name: 'Search by DFIS ID',
          path: 'report/dfis-id-report',
          component: () => import('@/views/report/dfis-id-report'),
          meta: { authorize: [] }
        },
        {
          name: 'Defect Report',
          path: 'report/defect-report',
          component: () => import('@/views/report/defect-report'),
          meta: { authorize: [] }
        },
        {
          name: 'Trainwise Report',
          path: 'report/trainwise-report',
          component: () => import('@/views/report/trainwise-report'),
          meta: { authorize: [] }
        },
        {
          name: 'Train Consolidated Report',
          path: 'report/train-information',
          component: () => import('@/views/report/train-information'),
          meta: { authorize: [] }
        },
        {
          name: 'Train Detail Report',
          path: 'report/train-detail-report',
          component: () => import('@/views/report/train-detail-report'),
          meta: { authorize: [] }
        }, 
        {
          name: 'Dashboard',
          path: 'dashboard',
          component: () => import('@/views/dashboard/Dashboard'),
          meta: { authorize: [] }
        },
        {
          name: 'DashboardManager',
          path: 'dashboardmgr',
          component: () => import('@/views/dashboard/DashboardManager'),
          meta: { authorize: [] }
        },
        {
          name: 'Users',
          path: 'userprofile',
          component: () => import('@/views/dashboard/UserProfile'),
          meta: { authorize: [store.state.logUserAdmin] }
        },
        {
          name: 'User Registration',
          path: 'register',
          component: () => import('@/views/dashboard/admin'),
          meta: { authorize: [store.state.logUserAdmin] }
        },
        {
          name: 'User Update',
          path: 'register',
          component: () => import('@/views/dashboard/admin'),
          meta: { authorize: [store.state.logUserAdmin] }
        },
        {
          name: 'Control Panel',
          path: 'panel',
          meta: { authorize: [store.state.logUserAdmin ] }
        },
        {
          name: 'Live View', //name of the page
          path: 'control-panel/dpu-live-view', //path of the page
          component: () => import('@/views/control-panel/dpu-live-view'), //dir of the page
          meta: { authorize: [store.state.logUserAdmin, store.state.logUserCCA ] }
        },
      ]
    },
  ]
});

router.beforeEach((to, from, next) => {
  // redirect to login page if not logged in and trying to access a restricted page
  const { authorize } = to.meta;
  const currentUser = router.app.$store.state.logUser; 
  let getLoggedInUser=window.localStorage.getItem("loggedInUser")

 
  if (authorize) {
    
      if (currentUser.length == 0) {     
          // not logged in so redirect to login page with the return url         
          return next({ path: '/', query: { returnUrl: to.path } });        
      } else {
        //else code
      }
  }
  next();
})
